export default function () {
  return {
    providers: [],
    loading: false,
  }
}
